import "./styles/home.scss";
import { motion } from "framer-motion"
import Sharearea from "./components/sharearea";
import Newsarea from "./components/newsarea";
import Careerarea from "./components/careerarea";
import ScrollEvent from '../../components/scrollevent';
function Home(props) {
    
    return (
        <>
            {/* banner */}
            <div className="banner mb-5">
                <motion.div
                    initial={{ opacity: 0, x:100 }}
                    whileInView={{ opacity: 1, x:0 }}
                    transition={{
                    delay: 0.4,
                    default: { ease: "linear" },
                    }}>
                    <img src="./homeImg/1.jpg" alt=""/>
                    
                </motion.div>
                <div className="bannerblock dis"></div>
                <div className="bannertext dis">
                    <div className="lgtext dis">
                        Becker<br />
                        <div className="lxtext">CPA<br /></div>
                        Exam Review<br />
                    </div>
                    全球最具權威領導品牌的<br />
                    財會培訓軟體<br />
                </div>
                <ScrollEvent/>
            </div>
            {/* news */}
            <Newsarea/>
            {/* video */}
            <div className="container-fluid mb100">
                    <div className="video-xl text-center">
                        <iframe width="800" height="400" src="https://www.youtube.com/embed/IM8PBAEKVD0" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                    </div>
                    <div className="video-l text-center">
                        <iframe width="350" height="250" src="https://www.youtube.com/embed/IM8PBAEKVD0" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                    </div>
            </div>
            {/* share */}
            <Sharearea/>
            <Careerarea />
        </>
    );
}
export default Home;